import { ActionType, GPSState } from '../../schemas/App/App.Schema';
import * as Constants from '../../utils/constants';
import produce from 'immer';
import { IONICWrapper } from '../../utils/common';

export const initialState: GPSState = {
  GPSData: [],
  UserDetails: {},
  UserDetailsNew:{},
  deviceRegistration: '',
  showAlert: false,
  alertMessage: '',
  alertTitle: '',
  moreContent: {},
  homeWebContent: {},
  offlineJSON: null,
  configParams: {},
  searchParams: null,
  pullToRefreshState: null,
  access_token: null,
  registerUserStatusMessage: {},
  session: {},
  tab_name: {},
  shipmentParams: null,
  searchedLoadByReferenceId: null,
  navigation: {},
  isCapacitor: false,
  isNotificationClosed: false,
  STOF_KEY: "",
  isContentStackApiCalled: false,
  webNotificationData: {notificationsData: [], newNotificationsCount: 0},
  notificationBellIconState: false,
  paramsDict:null,
  deepLinkURI:null,
  acceptLoadData : {},
  pcMillerData: []
};

export default (state = initialState, action: ActionType) =>
  produce(state, draft => {
    switch (action.type) {
      case Constants.SET_NAVIGATION:
        const __val: { [key: string]: string } = action.payload;
        draft.navigation = { ...draft.navigation, ...__val };
        break;
      case Constants.SET_STOF_KEY:
        draft.STOF_KEY = action.payload.city_code;
        break;
      case Constants.UPDATE_GPS_COORDS:
        draft.GPSData = [...draft.GPSData, action.payload];
        break;
      case Constants.FETCH_USER_DETAILS_SUCCESS:
        const _member = action.payload && action.payload.member
        if (_member) {
          let tempMember = { ...draft.UserDetailsNew.memberDetailsResponse.member, ..._member, upn: _member.userPrincipalName }
          draft.UserDetailsNew = { ...draft.UserDetailsNew, memberDetailsResponse: { ...draft.UserDetailsNew.memberDetailsResponse, member: tempMember } }
        }
        break;
        case Constants.FETCH_USER_DETAILS_NEW_SUCCESS:
          draft.UserDetailsNew = action.payload;
          break;
      case Constants.LOGOUT:
        draft.UserDetails = {};
        draft.GPSData = [];
        break;
      case Constants.REGISTER_DEVICE_RESPONSE_ACTION:
        draft.deviceRegistration = action.payload.errors;
        break;
      case Constants.SHOW_ALERT_MESSAGE:
        draft.showAlert = action.payload.isShowAlert;
        draft.alertMessage = action.payload.alertMessage;
        draft.alertTitle = action.payload.alertTitle;
        break;
      case Constants.HIDE_ALERT_MESSAGE:
        draft.showAlert = false;
        draft.alertMessage = '';
        draft.alertTitle = '';
        break;
      case Constants.MORE_TAB_CONTENT_RESPONSE:
        draft.moreContent = action.payload;
        break;
      case Constants.HOME_WEB_CONTENT_RESPONSE:
        draft.homeWebContent = action.payload;
        break;
      case Constants.MORE_TAB_CONTENT_RESPONSE_DUMMY:
        draft.offlineJSON.contentParams = action.payload;
        break;
      case Constants.CREATE_OFFLINE_JSON:
        draft.offlineJSON = action.payload;
        break;
      case Constants.GET_CONFIG_PARAMS:
        draft.configParams = action.payload;
        break;
      case Constants.UPDATE_SEARCH_PARAMS_OFFLINE:
        draft.offlineJSON[IONICWrapper.details.auth.user.upn].searchParams = {
          ...draft.offlineJSON[IONICWrapper.details.auth.user.upn].searchParams,
          ...action.payload
        };
        draft.searchParams = { ...draft.searchParams, ...action.payload };
        break;
      case Constants.UPDATE_SHIPMENT_INFO_OFFLINE:
        draft.offlineJSON[IONICWrapper.details.auth.user.upn].shipmentParams =
          action.payload;
        draft.shipmentParams = action.payload;
        break;
        case Constants.ACCEPT_LOAD_DATA:
          draft.acceptLoadData = action.payload;
          break;
        case Constants.PCMILLER_DATA:
          draft.pcMillerData = action.payload.data;
          break;
      case Constants.UPDATE_PULL_TO_REFRESH_STATE:
        draft.pullToRefreshState = action.payload;
        break;
      case Constants.STORE_ACCESS_TOKEN:
        draft.access_token = action.payload;
        break;
      case Constants.REGISTER_USER_STATUS_MESSAGE:
        draft.registerUserStatusMessage = action.payload;
        break;

      case Constants.CLEAR_REGISTER_USER_STATUS_MESSAGE:
        draft.registerUserStatusMessage = {};
        break;
      case Constants.SESSION_INFO:
        draft.session = action.payload.session;
        break;
      case Constants.TAB_NAME:
        draft.tab_name = action.payload.tab_name;
        break;
      case Constants.SEARCHED_LOAD_BY_ID:
        draft.searchedLoadByReferenceId = action.payload;
        break;
      case Constants.DEVICE_PLATFORM:
        draft.isCapacitor = action.payload;
        break;
      case Constants.SHOW_NOTIFICATION:
        draft.isNotificationClosed = action.payload;
        break;
      case Constants.API_CALLED:
        draft.isContentStackApiCalled = action.payload;
        break;
      case Constants.SET_USER_NOTIFICATIONS:
        draft.webNotificationData = action.payload;
        break;
      case Constants.UPDATE_NOTIFICATION_BELL_ICON:
        draft.notificationBellIconState = action.payload;
        break;
      case Constants.SET_DYNAMIC_LINK_PARAMS:
        draft.paramsDict = action.payload && action.payload.paramsDict || null;
        draft.deepLinkURI = action.payload && action.payload.deepLinkURI || null;
        break;
      case Constants.DEEPLINK_CLEANUP:
        draft.paramsDict = null;
        draft.deepLinkURI = null;
        break;
    }
  });
